import { addDays, format } from "date-fns";
import { makeAutoObservable } from "mobx";

import MealPlanFormStore from "./MealPlanFormStore";

export class Column {
  index: number;
  mode: "day" | "date" | "meal_pattern";

  private store: MealPlanFormStore;

  get date(): Date {
    if (this.mode == "meal_pattern") {
      return this.store.columns.startDate;
    }
    return addDays(this.store.columns.startDate, this.index - 1);
  }

  get day(): number {
    return this.index;
  }

  get label(): string {
    switch (this.mode) {
      case "day":
        return `Day ${this.day}`;
      case "date":
        return format(this.date, "MM/dd/yyyy");
      case "meal_pattern":
        return "Meal Pattern";
    }
  }

  get isEmpty(): boolean {
    let empty = true;
    for (const cell of this.cells) {
      empty = cell.isEmpty;
      // Return immediately if a cell is not empty because we don't need to
      // iterate anymore when a single cell is not empty.
      if (!empty) break;
    }
    return empty;
  }

  get totalEnergyKcal(): number {
    let energyKcal = 0;
    for (const cell of this.cells) {
      energyKcal += cell.totalEnergyKcal;
    }
    return energyKcal;
  }

  get isCalorieLimitReached(): boolean {
    return this.totalEnergyKcal > this.store.recommendedCaloriesKcal;
  }

  private get cells() {
    return this.store.rows.flatMap((plannedMeal) => {
      return this.store.cells.get(this, plannedMeal);
    });
  }

  constructor(store: MealPlanFormStore, index: number, mode?: "meal_pattern") {
    makeAutoObservable(this);
    this.store = store;
    this.index = index;
    this.mode = mode || (this.store.mode === "program" ? "date" : "day");
  }
}
